"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Basic = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var Icons = _interopRequireWildcard(require("@zip/react-icons/fearless"));

var _propTypes = require("prop-types");

var React = _interopRequireWildcard(require("react"));

var _utils = require("../../../utils");

var css = _interopRequireWildcard(require("./Dialog.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Basic = function Basic(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      actions = _ref.actions,
      _ref$spaceActions = _ref.spaceActions,
      spaceActions = _ref$spaceActions === void 0 ? false : _ref$spaceActions,
      _ref$showClose = _ref.showClose,
      showClose = _ref$showClose === void 0 ? true : _ref$showClose,
      children = _ref.children,
      fullWidth = _ref.fullWidth,
      _ref$mobileFullscreen = _ref.mobileFullscreen,
      mobileFullscreen = _ref$mobileFullscreen === void 0 ? false : _ref$mobileFullscreen,
      maxWidth = _ref.maxWidth,
      props = _objectWithoutProperties(_ref, ["title", "subtitle", "actions", "spaceActions", "showClose", "children", "fullWidth", "mobileFullscreen", "maxWidth"]);

  var _useScrollBottom = (0, _utils.useScrollBottom)(),
      _useScrollBottom2 = _slicedToArray(_useScrollBottom, 2),
      scrollAtBottom = _useScrollBottom2[0],
      scrollProps = _useScrollBottom2[1];

  var _useTheme = (0, _styles.useTheme)(),
      breakpoints = _useTheme.breakpoints;

  var matches = (0, _useMediaQuery["default"])(breakpoints.down('xs'));
  var contentRef = (0, React.useRef)(null);

  var handleCloseIconClick = function handleCloseIconClick(e) {
    props.onClose(e, 'backdropClick');
  }; // on initial load of component, set initial scrollAtBottom value


  (0, React.useEffect)(function () {
    if (!contentRef || !scrollProps) {
      return;
    }

    var setInitialScroll = function setInitialScroll(content) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore always function
      scrollProps.onScroll(content);
    };

    setInitialScroll(contentRef === null || contentRef === void 0 ? void 0 : contentRef.current); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentRef]);
  return (0, _jsxRuntime.jsxs)(_Dialog["default"], _objectSpread(_objectSpread({
    fullWidth: matches || fullWidth,
    maxWidth: !matches ? maxWidth : undefined,
    TransitionComponent: matches ? _Slide["default"] : undefined // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - `direction` is a valid property
    ,
    TransitionProps: matches ? {
      direction: 'up'
    } : undefined,
    css: css.dialogRoot(mobileFullscreen)
  }, props), {}, {
    children: [title && (0, _jsxRuntime.jsxs)(_DialogTitle["default"], {
      css: css.dialogTitle(!!subtitle),
      disableTypography: true,
      children: [(0, _jsxRuntime.jsxs)("p", {
        css: css.title,
        className: matches ? 'heading2' : 'heading1',
        children: [title, showClose && (0, _jsxRuntime.jsx)(Icons.Close, {
          css: css.closeIcon,
          onClick: handleCloseIconClick
        })]
      }), subtitle && (0, _jsxRuntime.jsx)("p", {
        className: "body2",
        css: css.subtitle,
        children: subtitle
      })]
    }), (0, _jsxRuntime.jsxs)(_DialogContent["default"], _objectSpread(_objectSpread({
      ref: contentRef
    }, scrollProps), {}, {
      children: [!title && showClose && (0, _jsxRuntime.jsx)(Icons.Close, {
        css: css.closeIcon,
        onClick: handleCloseIconClick
      }), children]
    })), actions && (0, _jsxRuntime.jsx)(_DialogActions["default"] // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - scrollAtBottom will always be Boolean
    , {
      css: css.dialogActions(scrollAtBottom, spaceActions),
      children: actions
    })]
  }));
};

exports.Basic = Basic;
Basic.displayName = 'Dialog';
Basic.propTypes = {
  /**
   * Supplemental actions represented by icons, text, and UI controls. Will be placed at the bottom of the dialog.
   */
  actions: _propTypes.node,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes.node.isRequired,

  /**
   * @deprecated The prop `disableBackdropClick` of `ForwardRef(Dialog)` is deprecated. Use the onClose prop with the `reason` argument to filter the `backdropClick` events.
   *
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: _propTypes.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: _propTypes.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: _propTypes.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   */
  fullWidth: _propTypes.bool,

  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: (0, _propTypes.oneOf)(['xs', 'sm', 'md', 'lg', 'xl', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: _propTypes.func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: _propTypes.func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _propTypes.func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _propTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: _propTypes.func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _propTypes.func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _propTypes.func,

  /**
   * If `true`, the Dialog is open.
   */
  open: _propTypes.bool.isRequired,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: (0, _propTypes.shape)({}),

  /**
   * If `true` the dialog will automatically add a close icon to the top right of the dialog
   */
  showClose: _propTypes.bool,

  /**
   * If `true`, `justify-content: space-between` and `flex-direction: row-reverse` css properties are applied to DialogActions element.
   */
  spaceActions: _propTypes.bool,

  /**
   * Subtitle added to the DialogTitle element, will cause title to be left aligned on mobile.
   */
  subtitle: _propTypes.string
};
Basic.defaultProps = {
  actions: undefined,
  disableBackdropClick: undefined,
  disableEscapeKeyDown: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'sm',
  onBackdropClick: undefined,
  onClose: undefined,
  onEnter: undefined,
  onEntered: undefined,
  onEntering: undefined,
  onEscapeKeyDown: undefined,
  onExit: undefined,
  onExited: undefined,
  onExiting: undefined,
  PaperProps: undefined,
  showClose: true,
  spaceActions: false,
  subtitle: undefined
};